import { createContext, forwardRef, useContext } from "react";

/* /inshur mode for the shared home-page sections.

   The INSHUR landing page reuses the home page's sections but, by the owner's rule
   (2026-09-30), has exactly two ways off it: leaving the site, or the hero's "Get
   Started" button. So on that page every other link becomes inert, the "Learn more"
   affordances and off-page buttons are not rendered, and a few sections change shape
   (see the `useInshurLanding()` branches in each component). The home page renders
   with the default `false` and is unaffected. */
export const InshurLandingContext = createContext(false);

export const useInshurLanding = () => useContext(InshurLandingContext);

/* A card that is a link on the home page and a plain, non-clickable box on the
   INSHUR landing page (same classes, so the card looks identical). */
export const CardLink = forwardRef(function CardLink({ href, children, ...rest }, ref) {
  const inshur = useInshurLanding();
  if (inshur) {
    return (
      <div ref={ref} {...rest}>
        {children}
      </div>
    );
  }
  return (
    <a ref={ref} href={href} {...rest}>
      {children}
    </a>
  );
});
